import { ApiCustomerIndividual } from '../../../../openapi';
import { UpdateLegalInfoForm } from '../../SettingsPage/UpdateLegalInfoForm';

export function isLegalInfoFilled(customer: ApiCustomerIndividual) {
  return Boolean(
    customer.name?.firstName &&
    customer.name?.lastName &&
    customer.birthInfo?.birthDate &&
    customer.birthInfo?.birthPlace?.country &&
    customer.birthInfo?.birthPlace?.city &&
    customer.legalSex,
  );
}

export function CustomerLegalInfoStep({ individual }: { individual: ApiCustomerIndividual }) {
  return <UpdateLegalInfoForm customer={individual} />;
}
